import React from 'react';
import { IconProps } from '../../Types';

export const IconBackGroundClientReviewBottomLeft = (props: IconProps) => {
    return (
        <svg width='653' height='445' viewBox='0 0 653 445' fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
            <circle cx='194' cy='472' r='327' fill='#D1E0FF'/>
            <circle opacity='0.5' cx='240.5' cy='412.5' r='412.5' fill='#D1E0FF'/>
        </svg>

    );
};

